import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Area, AreaChart, CartesianGrid, Line, LineChart, ResponsiveContainer,
  Tooltip, XAxis, YAxis,
} from "recharts";
import { TrendUp, Ranking } from "@phosphor-icons/react";

const CHART_TOOLTIP_STYLE = {
  backgroundColor: 'hsl(222, 47%, 9%)',
  border: '1px solid hsl(217, 32%, 17%)',
  borderRadius: '8px',
};
const POINTS_LINE_DOT = { fill: 'hsl(43, 90%, 55%)' };
const Y_DOMAIN = ['auto', 'auto'];

export default function PlayerChartsSection({ eloChartData, pointsChartData }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* ELO History Chart */}
      <Card className="bg-card border-border">
        <CardHeader>
          <CardTitle className="font-heading text-lg flex items-center gap-2">
            <TrendUp className="w-5 h-5 text-primary" weight="fill" />
            ELO Rating History
          </CardTitle>
        </CardHeader>
        <CardContent>
          {eloChartData.length > 1 ? (
            <ResponsiveContainer width="100%" height={200}>
              <AreaChart data={eloChartData}>
                <defs>
                  <linearGradient id="eloGrad" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="hsl(150, 60%, 45%)" stopOpacity={0.3} />
                    <stop offset="95%" stopColor="hsl(150, 60%, 45%)" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="hsl(217, 32%, 17%)" />
                <XAxis dataKey="date" stroke="hsl(215, 20%, 65%)" fontSize={11} />
                <YAxis stroke="hsl(215, 20%, 65%)" fontSize={11} domain={Y_DOMAIN} />
                <Tooltip contentStyle={CHART_TOOLTIP_STYLE} />
                <Area type="monotone" dataKey="elo" stroke="hsl(150, 60%, 45%)" fill="url(#eloGrad)" strokeWidth={2} />
              </AreaChart>
            </ResponsiveContainer>
          ) : (
            <div className="h-48 flex items-center justify-center text-muted-foreground text-sm">
              ELO history will appear after matches are played
            </div>
          )}
        </CardContent>
      </Card>

      {/* Points History Chart */}
      <Card className="bg-card border-border">
        <CardHeader>
          <CardTitle className="font-heading text-lg flex items-center gap-2">
            <Ranking className="w-5 h-5 text-secondary" weight="fill" />
            Points History
          </CardTitle>
        </CardHeader>
        <CardContent>
          {pointsChartData.length > 0 ? (
            <ResponsiveContainer width="100%" height={200}>
              <LineChart data={pointsChartData}>
                <CartesianGrid strokeDasharray="3 3" stroke="hsl(217, 32%, 17%)" />
                <XAxis dataKey="date" stroke="hsl(215, 20%, 65%)" fontSize={11} />
                <YAxis stroke="hsl(215, 20%, 65%)" fontSize={11} />
                <Tooltip contentStyle={CHART_TOOLTIP_STYLE} />
                <Line type="monotone" dataKey="points" stroke="hsl(43, 90%, 55%)" strokeWidth={2} dot={POINTS_LINE_DOT} />
              </LineChart>
            </ResponsiveContainer>
          ) : (
            <div className="h-48 flex items-center justify-center text-muted-foreground text-sm">
              No ranking history available
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
